import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IdelinkModuleTheme, useIdelinkTheme } from '../../configs/IdeLinkTheme';
import { NavbarModuleItem } from '../../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { Module } from '../Module';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { PrivateRoute } from '../../routes/PrivateRoute';
import { EventCreatePageLoading } from './Pages/Events/EventCreatePage/EventCreatePageLoading';
import { EventDetailsPageLoading } from './Pages/Events/EventDetailsPage/EventDetailsPageLoading';
import { EventListPageLoading } from './Pages/Events/EventListPage/EventListPageLoading';
import { ReminderCreatePageLoading } from './Pages/Reminders/ReminderCreatePage/ReminderCreatePageLoading';
import { ReminderDetailsPageLoading } from './Pages/Reminders/ReminderDetailsPage/ReminderDetailsPageLoading';
import { EventsPermissions } from './Services/EventsPermissions';
import { useIsPermissionsInitialized } from '../../../libs/IdeLink.Web.Common/src/Hooks/useIsPermissionsInitialized';

export class EventsModule {
    public static EVENT_LIST: string = '/events';
    public static EVENT_CREATE: string = '/events/create';
    public static EVENT_DETAILS: string = '/events/:id';

    public static REMINDER_BASE: string = '/reminders';
    public static REMINDER_CREATE: string = `${EventsModule.REMINDER_BASE}/create`;
    public static REMINDER_DETAILS: string = `${EventsModule.REMINDER_BASE}/:id`;

    //#region EVENTS

    private static getEventListRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: EventsModule.EVENT_LIST,
            component: EventListPageLoading,
        },
    });
    private static getEventCreateRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: EventsModule.EVENT_CREATE,
            component: EventCreatePageLoading,
        },
    });
    private static getEventDetailsRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: EventsModule.EVENT_DETAILS,
            component: EventDetailsPageLoading,
        },
    });
    public static eventDetailsRoute = (eventId: string): string => {
        return `${EventsModule.EVENT_DETAILS}`.replace(':id', eventId);
    };

    public static preloadEventListPage = () => {
        EventListPageLoading.preload();
        EventDetailsPageLoading.preload();
        EventCreatePageLoading.preload();
    };

    //#endregion

    //#region //* REMINDERS

    private static getReminderCreateRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: EventsModule.REMINDER_CREATE,
            component: ReminderCreatePageLoading,
        },
    });
    private static getReminderDetailsRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: EventsModule.REMINDER_DETAILS,
            component: ReminderDetailsPageLoading,
        },
    });

    public static reminderDetailsRoute = (reminderId: string): string => {
        return `${EventsModule.REMINDER_DETAILS}`.replace(':id', reminderId);
    };

    //#endregion

    public static getEventsRoutes = (): Array<RouteItem> => {
        //const { showCreateReminders } = useEventsConfig();
        let eventsRoutes = [
            EventsModule.getEventListRoute(),
            EventsModule.getEventCreateRoute(),
            EventsModule.getEventDetailsRoute(),
        ];
        //if (showCreateReminders) {
        eventsRoutes.push(
            EventsModule.getReminderCreateRoute(),
            EventsModule.getReminderDetailsRoute()
        );
        //}
        return eventsRoutes;
    };

    public static getEventsModuleNavbar = (eventsTheme: IdelinkModuleTheme): NavbarModuleItem => {
        return {
            icon: eventsTheme.navbarIcon,
            label: <FormattedMessage id="navbar.events" />,
            route: EventsModule.EVENT_LIST,
            onMouseOver: () => EventsModule.preloadEventListPage(),
            childRoutes: [EventsModule.REMINDER_BASE],
        };
    };
}

export const IdkEventsModule = () => {
    const ideLinkTheme = useIdelinkTheme();

    //this module need the permissions to load
    if (!useIsPermissionsInitialized()) {
        return null;
    }

    return (
        <Module
            moduleKey="EventsModule"
            permissionsItems={[EventsPermissions.getEventsTab()]}
            routes={EventsModule.getEventsRoutes()}
            navBarItems={[EventsModule.getEventsModuleNavbar(ideLinkTheme.events)]}
        />
    );
};
